if (!customElements.get('video-player')) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.cover = this.querySelector('.video-player__cover');
      this.videos = this.querySelectorAll('video');

      if (this.cover) {
        this.cover.addEventListener('click', this.play.bind(this));
      }
    }

    play() {
      this.videos.forEach(video => {
        video.play();
      });

      this.cover.classList.add('hidden')
      setUpResponsiveVideo();
    }
  }

  customElements.define('video-player', VideoPlayer);
}